import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import AddMenu from '../components/add-menu';

import ChoosePoint from './new-location';
import WritePost from './new-post';
import AddProfile from './new-profile';
import Publish from './new-publish';
import Errors from '../components/errors';
import moment from 'moment';
import 'moment-timezone';

import './new.css';

export default class Add extends Component {
	constructor(props) {
    super(props);

		this.newLocation = this.newLocation.bind(this);
		this.postAdd = this.postAdd.bind(this);
		this.profileAdd = this.profileAdd.bind(this);
		this.addUPT = this.addUPT.bind(this);
		this.publish = this.publish.bind(this);

		this.state = {
			authorized: false,
			published: false,
			upt: false,
			post: [],
			timezone: moment.tz.guess(),
			latitude: this.props.location.latitude,
			longitude: this.props.location.longitude,
			locked: false,
		}
	}

	componentWillMount() {
		console.log('checking if the user is logged in', this.props);
		if(this.props.data.authorized === true) {
			this.setState({ authorized: true });

			if(!this.props.data.user.id) {
				this.setState({ authorized: false });
			} else {
				this.setState({ user: this.props.data.user.id });
			}
			if(!this.props.data.user.hash) {
				this.setState({ authorized: false });
			} else {
				this.setState({ hash: this.props.data.user.hash });
			}
		} else {
			this.setState({ authorized: false });
		}
	}

	newLocation(data) {
		console.log(data);
		this.setState({
			latitude: data.latitude,
			longitude: data.longitude,
			locked: data.locked
		});
	};

	postAdd(data) {
		this.setState({ post: data });
	};

	profileAdd(data) {
		this.setState({
			name: data.name,
			description: data.description,
			url: data.url,
			email: data.email,
			phone: data.phone
		});
	};

	addUPT(data) {
		console.log('addUPT', data.upt);
		this.setState({ upt: data.upt });
	};

	publish(data) {
		console.log('Preparing to publish', this.state);

		if(this.state.latitude && this.state.longitude && this.state.post && this.state.upt) {

			let data = {
				user: this.state.user,
				hash: this.state.hash,
				latitude: this.state.latitude,
				longitude: this.state.longitude,
				upt: moment(this.state.upt).utc().format("YYYY-MM-DD HH:mm:ss"),
				timezone: this.state.timezone,
				post: this.state.post,
				name: this.state.name,
				description: this.state.description,
				url: this.state.url,
				email: this.state.email,
				phone: this.state.phone
			}

			console.log(data);

			let images = [];

			// upload images and get url-s
			data.post = data.post.map(function (row, key) {
					if(row.type === "text") {

						console.log('text', row);
						return '<p>' + row.value.replace(/(\r\n\t|\n|\r\t)/gm,"") + '</p>';

					} else if(row.type.slice(0, 7) === "iframe/") {

						console.log('iframe', row);
						return '<iframe src="' + row.value.replace(/(\r\n\t|\n|\r\t)/gm,"") + '" />';

					} else if(row.type.slice(0, 6) === "image/") {

						console.log('image', row);

						images.push(
							fetch('https://atround.com/services/image.php', {
								method: "POST",
								headers: {
					    		"Accept": "application/json",
					  		},
								credentials: 'include',
								body: JSON.stringify(row)
							})
							.then(response => response.json())
							.then(
								(result) => {
									console.log(result);
									const newimage = {
										key: key,
										type: row.type,
										value: result.data,
									}
									return newimage;
								}
							)
						);

					} else {

						console.log('text', row);
						return "<p>" + row.value + "</p>";

					}

					return row;
			});

			Promise
				.all(images)
				.then(results => {
					console.log('Promises OK', results);

					results.map(image => {
						console.log(image);
						data.post[image.key] = '<img src="' + image.value.replace(/(\r\n\t|\n|\r\t)/gm,"") + '" />';
						return true;
					});
					console.log('after promises', data.post);

					data.post = data.post.join("\n");

					console.log('MOMENT B€3 SENDING:', data.post);
					fetch('https://atround.com/services/add-post.php',
					{
						method: "POST",
						headers: {
			    		"Accept": "application/json",
			  		},
						credentials: 'include',
						body: JSON.stringify(data)
					})
					.then(response => response.json())
					.then(
						(result) => {
							if(result.error === false) {
								console.log('OK. ', result);
								this.setState({
									published: true,
									data: result
								});
							} else {
								console.log('ERR: server returned error: ', result, this.props);

								if(result.error.code) {
									if(result.error.code === 'NO-AUTH') {
										this.props.onStatusChange(false);
									}

									this.setState({
										error: result.error.code
									});
								}
							}
						},
						// Note: it's important to handle errors here
						// instead of a catch() block so that we don't swallow
						// exceptions from actual bugs in components.
						(error) => {
							console.log(error);
							this.setState({
			          published: false,
			          error: error
			        });
						}
					)
				});
		} else {

			this.setState({
				published: false,
				error: 'POST-REQ-NOK'
			});
		}
	};


	render() {
    console.log('ADD render', this.state, this.props);

		if(this.state.authorized === false) {
			console.log(this.state, 'authorized: false');
			return <Redirect to="/login/add" />
		}

		if(this.state.published === true) {

			console.log(this.state, 'published: true');
			return <Redirect to="/justadded" />

		} else {
			console.log(this.state, 'published: false', this.state.error);
		}

		console.log(this.state.locked, this.state.post.length, this.props.path.pathname);

		if(this.state.locked === false) {
			if(this.props.path.pathname !== "/add/location") {
				console.log('Location unlocked');
				return <Redirect to="/add/location" />
			}

		} else if(this.state.post.length === 0) {

			if(this.props.path.pathname === "/add/location") {
			} else if(this.props.path.pathname !== "/add/post") {
				console.log('No content');
				return <Redirect to="/add/post" />
			}
		}

    return (
			<div id="add-new">
				<Errors error={ this.state.error } />
				<AddMenu data={this.state}/>
				<Switch>
					<Route path="/add/location" render={ () => <ChoosePoint data={this.state} onLocationChange={ this.newLocation } /> }/>
					<Route path="/add/post" render={ () => <WritePost data={this.state} onPostAdd={ this.postAdd }/> } />
					<Route path="/add/profile" render={ () => <AddProfile data={this.state} onProfileAdd={ this.profileAdd }/> } />
					<Route path="/add/publish" render={ () => <Publish data={this.state} onUPTAdd={ this.addUPT } onPublish={ this.publish }/> } />
				</Switch>
			</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/new.jsx